import { createClient } from '@/shared/api';
import MORPHOLOGY_OVERVIEW from '@/entities/beat/api/queries/morphologyOverview';
import type {
  MorphologyOverviewQuery,
  MorphologyOverviewQueryVariables,
} from '@/shared/api/generated/graphql';

export type MorphologyOverviewItem = {
  id: string;
  centerVector: any;
  total: number;
  reviewed: number;
  isIncludedToReport: boolean;
  unclassified: number;
  rrHeatMapCells: { id: string; total: number; reviewed: number }[];
};

export type MorphologyOverviewQueryResult = {
  isSuccess: boolean;
  message: string;
  morphologyOverview: MorphologyOverviewItem[];
};

// TODO(ts): typed as the MorphologyOverviewInput GraphQL input once its server-side shape is documented
/**
 * Loads the beat morphology overview backing the beats tab. Queries morphologyOverview through an Apollo client that caches by default and returns that field, tolerating a nullish response.
 *
 * @param input - Query input identifying the study and morphology scope.
 * @param isUsingCache - Whether the Apollo client should serve from cache; defaults to true.
 * @returns A promise resolving to the morphology overview data.
 */
const fetchMorphologyOverview = async (input: any, isUsingCache = true) => {
  const client = await createClient(isUsingCache);
  const result = await client.query<MorphologyOverviewQuery, MorphologyOverviewQueryVariables>({
    query: MORPHOLOGY_OVERVIEW,
    variables: { input },
  });
  const { data } = result || {};
  const { morphologyOverview } = data || {};
  return morphologyOverview;
};

export default fetchMorphologyOverview;
